module.exports = __webpack_public_path__ + "img/tiktok.e31ef15b.jpeg";